import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyjsonc'
})
export class PrettyjsoncPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
